<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<form novalidate class="row" [formGroup]="filtersForm">

  <mat-form-field class="col-md-4" class="col-md-3">
    <mat-label>{{ "forms.common.Arabic Label" | translate }}</mat-label>
    <input matInput formControlName="arabicName" />
  </mat-form-field>

  <mat-form-field class="col-md-4" class="col-md-3">
    <mat-label>{{ "forms.common.English Label" | translate }}</mat-label>
    <input matInput formControlName="englishName" />
  </mat-form-field>

  <mat-form-field class="col-md-4" class="col-md-3">
    <mat-label>{{ "forms.common.Email" | translate }}</mat-label>
    <input matInput formControlName="mainEmail" />
  </mat-form-field>

  <mat-form-field class="col-md-3">
    <mat-label>{{ "forms.common.gender" | translate }}</mat-label>
    <mat-select formControlName="gender">
      <mat-option *ngFor="let option of gender" [value]="option.value">
        {{'forms.common.' + option.label | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <ng-container *ngIf="nationalities$ | async as nationalities">
    <mat-form-field class="col-md-3">
      <mat-label>{{ "forms.common.nationality" | translate }}</mat-label>
      <mat-select formControlName="nationality">
        <mat-option *ngFor="let option of nationalities" [value]="option.value">
          {{'forms.common.' + option.label | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="col-md-3">
      <mat-label>{{ "forms.common.ResidenceCountry" | translate }}</mat-label>
      <mat-select formControlName="residenceCountry">
        <mat-option *ngFor="let option of nationalities" [value]="option.value">
          {{'forms.common.' + option.label | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

  <mat-form-field class="col-md-3">
    <mat-label>{{ "forms.common.ResidencePlace" | translate }}</mat-label>
    <mat-select formControlName="residencePlace">
      <mat-option *ngFor="let option of residencePlace" [value]="option.value">
        {{'forms.common.' + option.label | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="col-md-3" *ngIf="filtersForm.value.residencePlace == 'local'">
    <mat-label>{{ "forms.common.ResidenceCity" | translate }}</mat-label>
    <mat-select formControlName="localResidenceCity">
      <mat-option *ngFor="let option of localResidenceCity$ | async" [value]="option.value">
        {{'forms.common.' + option.value | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  
  <mat-form-field class="col-md-4" class="col-md-3">
    <mat-label>{{ "forms.common.workSide" | translate }}</mat-label>
    <input matInput formControlName="workDestination" />
  </mat-form-field>

  <mat-form-field class="col-md-3">
    <mat-label>{{ "forms.common.Languages" | translate }}</mat-label>
    <mat-select formControlName="language">
      <mat-option *ngFor="let option of languages$ | async" [value]="option.value">
        {{'forms.common.' + option.value | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="col-md-4" class="col-md-3">
    <mat-label>{{ "forms.common.delicateSpecialization" | translate }}</mat-label>
    <input matInput formControlName="delicateSpecialization" />
  </mat-form-field>

  <mat-form-field class="col-md-3">
    <mat-label>{{ "forms.common.publicSpecialty" | translate }}</mat-label>
    <mat-select formControlName="generalSpecialty">
      <mat-option *ngFor="let option of generalSpecialty$ | async" [value]="option.value">
        {{'forms.common.' + option.value | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="col-md-12 d-flex justify-content-end">
    <button mat-flat-button color="primary" (click)="search()" class="py-1 px-5" type="button">
      {{ "forms.common.Search" | translate }}
    </button>
    <button mat-flat-button (click)="clear()" class="py-1" type="button">
      {{ "forms.common.Reset" | translate }}
    </button>
  </div>
</form>